// Studyo Today Backend
// Package studyo.today.sel.v1
// Service definitions
// Copyright (c) 2015-2022 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/sel/v1/sel.proto (package studyo.today.sel.v1, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_google_type_date } from "@buf/googleapis_googleapis.bufbuild_es/google/type/date_pb.js";
import { file_studyo_today_sel_v1_resources_aggregation_strategy } from "./resources/aggregation_strategy_pb.js";
import { file_studyo_today_sel_v1_resources_emotional_pulse } from "./resources/emotional_pulse_pb.js";

/**
 * Describes the file studyo/today/sel/v1/sel.proto.
 */
export const file_studyo_today_sel_v1_sel = /*@__PURE__*/
  fileDesc("Ch1zdHVkeW8vdG9kYXkvc2VsL3YxL3NlbC5wcm90bxITc3R1ZHlvLnRvZGF5LnNlbC52MSK/AQoZR2V0RW1vdGlvbmFsUHVsc2VzUmVxdWVzdBIQCgh1c2VyX2lkcxgBIAMoCRIfCgRmcm9tGAIgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZRIdCgJ0bxgDIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSUAoUYWdncmVnYXRpb25fc3RyYXRlZ3kYBCABKA4yMi5zdHVkeW8udG9kYXkuc2VsLnYxLnJlc291cmNlcy5BZ2dyZWdhdGlvblN0cmF0ZWd5ImUKGkdldEVtb3Rpb25hbFB1bHNlc1Jlc3BvbnNlEkcKEGVtb3Rpb25hbF9wdWxzZXMYASADKAsyLS5zdHVkeW8udG9kYXkuc2VsLnYxLnJlc291cmNlcy5FbW90aW9uYWxQdWxzZSJqCiBHZXRDdXJyZW50RW1vdGlvbmFsUHVsc2VSZXNwb25zZRJGCg9lbW90aW9uYWxfcHVsc2UYASABKAsyLS5zdHVkeW8udG9kYXkuc2VsLnYxLnJlc291cmNlcy5FbW90aW9uYWxQdWxzZSIqChhTZXRFbW90aW9uYWxTdGF0ZVJlcXVlc3QSDgoGcmF0aW5nGAEgASgFMtoCCgNTZWwSdQoSR2V0RW1vdGlvbmFsUHVsc2VzEi4uc3R1ZHlvLnRvZGF5LnNlbC52MS5HZXRFbW90aW9uYWxQdWxzZXNSZXF1ZXN0Gi8uc3R1ZHlvLnRvZGF5LnNlbC52MS5HZXRFbW90aW9uYWxQdWxzZXNSZXNwb25zZRJpChhHZXRDdXJyZW50RW1vdGlvbmFsUHVsc2USFi5nb29nbGUucHJvdG9idWYuRW1wdHkaNS5zdHVkeW8udG9kYXkuc2VsLnYxLkdldEN1cnJlbnRFbW90aW9uYWxQdWxzZVJlc3BvbnNlEnEKEVNldEVtb3Rpb25hbFN0YXRlEi0uc3R1ZHlvLnRvZGF5LnNlbC52MS5TZXRFbW90aW9uYWxTdGF0ZVJlcXVlc3QaLS5zdHVkeW8udG9kYXkuc2VsLnYxLnJlc291cmNlcy5FbW90aW9uYWxQdWxzZUIbqgIYU3R1ZHlvLlRvZGF5LlNlbC5HcnBjLlYxYgZwcm90bzM", [file_google_protobuf_empty, file_google_type_date, file_studyo_today_sel_v1_resources_aggregation_strategy, file_studyo_today_sel_v1_resources_emotional_pulse]);

/**
 * Describes the message studyo.today.sel.v1.GetEmotionalPulsesRequest.
 * Use `create(GetEmotionalPulsesRequestSchema)` to create a new message.
 */
export const GetEmotionalPulsesRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_sel_v1_sel, 0);

/**
 * Describes the message studyo.today.sel.v1.GetEmotionalPulsesResponse.
 * Use `create(GetEmotionalPulsesResponseSchema)` to create a new message.
 */
export const GetEmotionalPulsesResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_sel_v1_sel, 1);

/**
 * Describes the message studyo.today.sel.v1.GetCurrentEmotionalPulseResponse.
 * Use `create(GetCurrentEmotionalPulseResponseSchema)` to create a new message.
 */
export const GetCurrentEmotionalPulseResponseSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_sel_v1_sel, 2);

/**
 * Describes the message studyo.today.sel.v1.SetEmotionalStateRequest.
 * Use `create(SetEmotionalStateRequestSchema)` to create a new message.
 */
export const SetEmotionalStateRequestSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_sel_v1_sel, 3);

/**
 * API Definition for the Student Emotional Learning service.
 *
 * @generated from service studyo.today.sel.v1.Sel
 */
export const Sel = /*@__PURE__*/
  serviceDesc(file_studyo_today_sel_v1_sel, 0);

